import api from './api';

/**
 * Personal Notifications API Service
 * Handles notifications specific to personal workspace
 */

// Get personal notifications with pagination and filters
export const getPersonalNotifications = async (params = {}) => {
  const { data } = await api.get('/personal/notifications', { params });
  return data;
};

// Get unread personal notification count
export const getPersonalUnreadCount = async () => {
  const { data } = await api.get('/personal/notifications/unread-count');
  return data;
};

// Mark personal notification as read
export const markPersonalNotificationAsRead = async (notificationId) => {
  const { data } = await api.put(`/personal/notifications/${notificationId}/read`);
  return data;
};

// Mark all personal notifications as read
export const markAllPersonalNotificationsAsRead = async () => {
  const { data } = await api.put('/personal/notifications/read-all');
  return data;
};

// Delete personal notification
export const deletePersonalNotification = async (notificationId) => {
  const { data } = await api.delete(`/personal/notifications/${notificationId}`);
  return data;
};

// Delete all read personal notifications
export const deleteReadPersonalNotifications = async () => {
  const { data } = await api.delete('/personal/notifications/read');
  return data;
};

export default {
  getPersonalNotifications,
  getPersonalUnreadCount,
  markPersonalNotificationAsRead,
  markAllPersonalNotificationsAsRead,
  deletePersonalNotification,
  deleteReadPersonalNotifications
};
